import { render, staticRenderFns } from "./CoverageTracker.vue?vue&type=template&id=25c5d59a&scoped=true"
import script from "./CoverageTracker.vue?vue&type=script&lang=js"
export * from "./CoverageTracker.vue?vue&type=script&lang=js"
import style0 from "./CoverageTracker.vue?vue&type=style&index=0&id=25c5d59a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c5d59a",
  null
  
)

export default component.exports